/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-06-21 09:23:23
 * @FilePath: \monitor\src\libs\tools.js
 * @Description: 
 */

'use strict';
const Tools = {
  methods: {
    StorageSet: function (obj) {
      sessionStorage[obj.key] = JSON.stringify(obj.val);
    },
    StorageDel: function (key) {
      sessionStorage.removeItem(key);
    },
    StorageGet: function (key) {
      let _key = sessionStorage.getItem(key);
      return _key ? JSON.parse(_key) : _key;
    },
    GetParam: function (item) {
      let sValue = location.hash.match(new RegExp("[\?\&]" + item + "=([^\&]*)(\&?)", "i"));
      //let isUrlCode =/\%+/ig; "[\?\&]" + item + "=([^\&]*)(\&?)", "i")
      return sValue ? sValue[1] : sValue;
    },
    monthFillDay: function (timeArr) {
      let month = parseInt(timeArr[1], 10); //parseInt(number,type)这个函数后面如果不跟第2个参数来表示进制的话，默认是10进制。
      let tempData = new Date(timeArr[0], timeArr[1], 0);
      return tempData.getDate().toString();
    },
    //时间转换成毫秒
    ConvertTimeMs: function (timeStr, str) {
      let _str = str || ".";
      let _month = timeStr.substring(5, timeStr.lastIndexOf(_str));
      let _day = timeStr.substring(timeStr.length, timeStr.lastIndexOf(_str) + 1);
      let _year = timeStr.substring(0, timeStr.indexOf(_str));
      return Date.parse(_month + '/' + _day + '/' + _year)
    },
    //客户端时间计算
    GetNowFormatDate: function (str, ms) {
      var date = ms ? new Date(ms) : new Date();
      var seperator1 = str || "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month + seperator1 + strDate;
    },
    //上年同月 上年同月同日
    GetPreYearMonthData: function (str, ms, bool) {
      var timeSep = 365 * 24 * 3600 * 1000;
      var seperator1 = str || "";
      var now = new Date();
      var date = ms ? new Date(ms - timeSep) : new Date(now.getTime() - timeSep);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate() - 1;
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }

      if (bool) {
        return year + seperator1 + month + seperator1 + day;
      } else {
        return year + seperator1 + month;
      }
    },
    //上周同日
    GetPreWeekNowData: function (str, ms) {
      var timeSep = 7 * 24 * 3600 * 1000;
      var seperator1 = str || "";
      var now = new Date();
      var date = ms ? new Date(ms - timeSep) : new Date(now.getTime() - timeSep);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }

      return year + seperator1 + month + seperator1 + day;
    },
    //求两个时间的天数差 日期格式为 YYYY.MM.dd
    DaysBetween: function (DateOne, DateTwo, str) {
      var _str = str || ".";
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf(_str));
      var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf(_str) + 1);
      var OneYear = DateOne.substring(0, DateOne.indexOf(_str));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf(_str));
      var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf(_str) + 1);
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf(_str));

      var cha = ((Date.parse(OneMonth + '/' + OneDay + '/' + OneYear) - Date.parse(TwoMonth + '/' + TwoDay + '/' + TwoYear)) / 86400000);
      return cha;//Math.abs(cha)
    },
    //传递时间参数转换
    timeParamFormatShow: function (timeStr, bool) {
      var res = "";
      if (bool) {
        res = timeStr.slice(0, 4) + "-" + timeStr.slice(4, 6) + "-" + timeStr.slice(6, 8);
      } else {
        res = timeStr.slice(0, 4) + "-" + timeStr.slice(4, 6);
      }
      return res;

    },
    timeQueryFormat: function (timeStr, sep) {
      let _sep = sep || "-";
      return timeStr.split(_sep).join("");
    }
  },
  cordova: {

    initialize: function () {
      this.bindEvents();
    },

    bindEvents: function () {
      document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
    },
    onDeviceReady: function () {
      //this.checkConnection();
      //返回按键
      //document.addEventListener("backbutton", this.onBackKeyDown, false);
      //网络环境
      document.addEventListener("offline", this.onOffLine.bind(this), false);
      //document.addEventListener("online", this.onLine.bind(this), false);
    },
    onUpdateApp: function () {
      this.onClearApp();
      //错误提示
      let _onUpdateError = (error) => {
        switch (error.code) {
          case 1:
            this.onToast("安装请求被发送到插件,但没有安装");
            break;
          case 2:
            this.onToast("当前已经是最新版本");
            break;
          case -1:
            this.onToast("无法从服务器下载新的应用程序配置或网络连接问题");
            break;
          case -2:
            this.onToast("应用程序的版本版本太低。新的Web版本需要新版本的应用程序。用户必须通过商店更新它");
            //navigator.app.loadUrl('',{wait: 0, loadingDialog: "Wait,Loading App", loadUrlTimeoutValue: 6000});//加载 web 页面的应用程序中或者系统默认的浏览器中
            cordova.InAppBrowser.open('http://www.baidu.com', '_blank', 'location=yes');
            break;
          case -3:
            this.onToast("无法从服务器下载新的内容清单文件");
            break;
          case -4:
            this.onToast("无法从服务器下载更新/新文件");
            break;
          case -5:
            this.onToast("未能将下载的文件移动到安装文件夹。可以在设备上没有空闲空间");
            break;
          case -6:
            this.onToast("更新包被破坏了");
            break;
          default:
            this.onToast('无法加载更新与错误代码: ' + error.code + ':' + error.description);
        }
      };
      chcp.fetchUpdate((error, data) => {
        if (error) {
          _onUpdateError(error);
          return
        }
        this.onToast('下载已经完成,正在运行安装...');
        chcp.installUpdate((error) => {
          if (error) {
            _onUpdateError(error);
          } else {
            this.onToast('更新安装完成!');
          }
        });
      });
    },
    onBackKeyDown: function () {
      let isHomeUrl = /(^#\!\/admin\/home$|^#\!\/admin\/home\?\S*)+/i.test(location.hash);
      let isLoginUrl = /(^#\!\/login$|^#\!\/login\?\S*)+/i.test(location.hash);
      if (isHomeUrl || isLoginUrl) {
        navigator.notification.confirm('确认退出?', function (buttonIndex) {
          if (buttonIndex == 1) {
            navigator.app.exitApp();
          } else {
            navigator.app.cancelLoadUrl();
          }
        }, '提示', ['确定', '取消']);
      } else {
        navigator.app.backHistory();//相当于浏览器的后退
      }
    },
    onClearApp: function () {
      window.cache.clear(function (status) {
        window.plugins.toast.showShortCenter('清除缓存成功!');
        navigator.app.clearHistory();//清空浏览历史
        navigator.app.clearCache();//清空程序的资源文件缓存
      }, function (status) {
        window.plugins.toast.showShortCenter('清除缓存失败:' + status)
      });
      window.cache.cleartemp();
    },
    onSplashScreen: function (bool) {
      if (bool) {
        //启动画面显示 ，如果要显示该效果，需要把上面黑体部分注释掉
        navigator.splashscreen.show();
      } else {
        //隐藏画面隐藏
        navigator.splashscreen.hide();
      }
    },
    checkConnection: function () {
      var networkState = navigator.connection.type;

      var states = {};
      states[Connection.UNKNOWN] = 'Unknown';
      states[Connection.ETHERNET] = 'Ethernet';
      states[Connection.WIFI] = 'WiFi';
      states[Connection.CELL_2G] = '2G';
      states[Connection.CELL_3G] = '3G';
      states[Connection.CELL_4G] = '4G';
      states[Connection.CELL] = 'generic';
      states[Connection.NONE] = 'No network';

      this.onToast('当前网络链接: ' + states[networkState]);
    },
    onOffLine: function () {
      this.onToast('当前网络状态不好!,请检查网络...');
    },
    onLine: function () {
      this.onToast('网络已经连接!');
    },
    onToast: function (msg) {
      window.plugins.toast.showShortCenter(msg,
        function (a) {
          console.log('toast success: ' + a)
        },
        function (b) {
          alert('toast error: ' + b)
        }
      )
    }
  }
};
export default Tools;



// WEBPACK FOOTER //
// ./src/libs/tools.js